/** @jsxRuntime classic */
/** @jsx jsx */
import { InterpolationWithTheme, jsx } from '@emotion/core';
import { List } from 'antd';
import { useStyles } from '~src/hooks/useStyles';
import QuestionItem, {
  QuestionItemProps,
} from '~components/atoms/Questions/QuestionItem';
import { DbQuestion } from '~src/types/db';
import { AnswerFormValues } from './AnswerQuickForm';
import { styleFn } from './QuestionsList.styles';
import { ReactNode } from 'react';

export type PaginationParams = {
  current: number;
  pageSize: number;
  total: number;
  hasMore: boolean;
};

export type QuestionsListProps = {
  questions: DbQuestion[] | undefined;
  isLoading: boolean;
  pagination: PaginationParams;
  handlePaginationChange: (page: number, pageSize?: number) => void;
  onAnswer?: (
    answerData: AnswerFormValues,
    questionsId: number
  ) => Promise<unknown>;
  onAccept?: (questionsId: number) => Promise<unknown>;
  onReject?: (questionsId: number) => Promise<unknown>;
  onIgnore?: (questionsId: number) => Promise<unknown>;
  onReactivate?: (questionsId: number) => Promise<unknown>;
  questionsListCss?: InterpolationWithTheme<any>;
  header?: ReactNode;
  split?: boolean;
  insideOfBtn?: boolean;
  isOnTender?: boolean;
  hideInternalPagination?: boolean;
} & Pick<QuestionItemProps, 'questionItemConfig'>;

const QuestionsList: React.FC<QuestionsListProps> = ({
  questions,
  isLoading,
  pagination,
  handlePaginationChange,
  onAnswer,
  onAccept,
  onReject,
  onIgnore,
  onReactivate,
  questionsListCss,
  questionItemConfig,
  header,
  split,
  insideOfBtn,
  isOnTender,
  hideInternalPagination = false,
}) => {
  const styles = useStyles(styleFn);

  const isProjectSide = !isOnTender;

  return (
    <div
      css={[
        styles.container,
        // isProjectSide &&
        {
          height: 'auto',
          paddingLeft: 0,
          paddingBottom: 0,
        },
        insideOfBtn && { height: '100%' },
      ]}>
      <List
        header={header}
        css={[
          questionsListCss || styles.questionsList,
          // isProjectSide &&
          {
            maxWidth: '100%',
            minWidth: '100%',
            width: '100%',
          },
        ]}
        dataSource={questions}
        loading={isLoading}
        split={split}
        pagination={
          !hideInternalPagination && questions && questions?.length > 0
            ? {
                ...pagination,
                onChange: handlePaginationChange,
                showSizeChanger: false,
                style: { display: 'flex', justifyContent: 'center' },
              }
            : false
        }
        renderItem={(question) => (
          <QuestionItem
            question={question}
            onAnswer={
              onAnswer && (async (data) => onAnswer?.(data, question.id))
            }
            onAccept={async () => onAccept?.(question.id)}
            onReject={async () => onReject?.(question.id)}
            onIgnore={async () => onIgnore?.(question.id)}
            onReactivate={async () => onReactivate?.(question.id)}
            questionItemConfig={questionItemConfig}
            isOnTender={isOnTender}
          />
        )}
      />
    </div>
  );
};

export default QuestionsList;
